import { addHours } from 'date-fns';

/** When the activity is treated as "ended" for wishlist expiry (matches feed visibility rules). */
export function getWishlistActivityEnd(activity) {
  const raw = activity.expiresAt || activity.dateTime;
  return new Date(raw);
}

/** Past end time but still within 24h grace (show grayed category on wishlist). */
export function isWishlistExpiredGrace(activity, now = new Date()) {
  const end = getWishlistActivityEnd(activity);
  return now > end && now <= addHours(end, 24);
}

/** Remove from wishlist storage after end + 24 hours. */
export function isWishlistPastRemovalGrace(activity, now = new Date()) {
  const end = getWishlistActivityEnd(activity);
  return now > addHours(end, 24);
}

export function wishlistStoredItemPastRemoval(endAtIso, now = new Date()) {
  if (!endAtIso) return false;
  const end = new Date(endAtIso);
  return now > addHours(end, 24);
}
